var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "#3ceac1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4955 15.5H0.742188V19.0003H2.49358V17.2514H23.4952V19.0003H25.2466V15.5H23.4955Z",
    fill: "#3ceac1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2458 5H7.74248C6.81388 4.99928 5.92324 5.36795 5.26668 6.0245C4.61013 6.68105 4.24145 7.57169 4.24219 8.50029V13.7522H21.7464V8.50029C21.7464 7.57206 21.3776 6.68161 20.7212 6.02523C20.0648 5.36886 19.1745 5 18.2461 5H18.2458Z",
    fill: "#3ceac1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 10.25H2.49358V13.7503H0.742188V10.25Z",
    fill: "#3ceac1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.25H25.2514V13.7503H23.5V10.25Z",
    fill: "#3ceac1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.1a48f9c0f499fa5b544d379d7372775b.svg";
export { ForwardRef as ReactComponent };